module.exports = __webpack_public_path__ + "img/wsb-howtoplay-images-04.d4e974f1.jpg";